import React, { useState } from "react";
import { formatMoney } from "../utils/utils";
import axiosInstance from "../config/axiosConfig";
import MonthInput from "./components/MonthInput";

const CompararPeriodo = () => {
  // Datos predefinidos de pagos por período

  // Estado para almacenar los períodos seleccionados
  const [periodo1, setPeriodo1] = useState("");
  const [periodo2, setPeriodo2] = useState("");
  const [detallesPeriodo1, setDetallesPeriodo1] = useState([]);
  const [detallesPeriodo2, setDetallesPeriodo2] = useState([]);

  const totalPeriodo1 = detallesPeriodo1.reduce((sum, pago) => sum + pago.total, 0);
  const totalPeriodo2 = detallesPeriodo2.reduce((sum, pago) => sum + pago.total, 0);

  // Función para buscar los detalles de un período
  const buscarDetalles = async (periodo) => {
    const [año, mes] = periodo.split("-");
    const response = await axiosInstance.post("/financiero/cartola/compara", { 'periodo': periodo });
    const data = response.data.data;

    // Transformar los datos para adaptarse al componente
    return data.map((mov) => ({
      nombrePaciente: mov.detalle, // o extraer el nombre del detalle si es posible
      nombreAuxiliar: "", // No viene este dato, puedes dejarlo vacío o deducirlo
      dias: "", // No disponible, puedes omitirlo o poner 0
      total: parseFloat(mov.monto) // Convertir string a número
    }));
  };

  // Función para comparar los períodos
  const compararPeriodos = async () => {
    if (!periodo1 || !periodo2) {
      alert("Por favor, selecciona ambos períodos.");
      return;
    }
  
    try {
      const [detalles1, detalles2] = await Promise.all([
        buscarDetalles(periodo1),
        buscarDetalles(periodo2)
      ]);
  
      setDetallesPeriodo1(detalles1);
      setDetallesPeriodo2(detalles2);
    } catch (error) {
      console.error("Error al comparar períodos:", error);
      alert("Ocurrió un error al obtener los datos.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h3 className="card-title">Comparar Períodos de Pagos</h3>
        </div>
        <div className="card-body">
          {/* Formulario para seleccionar períodos */}
          <div className="row mb-4">
            <div className="col-md-6">
              <label htmlFor="periodo1" className="form-label">
                Período 1
              </label>
              <MonthInput
                className="form-control"
                id="periodo1"
                value={periodo1}
                onChange={(e) => setPeriodo1(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="periodo2" className="form-label">
                Período 2
              </label>
              <MonthInput
                className="form-control"
                id="periodo2"
                value={periodo2}
                onChange={(e) => setPeriodo2(e.target.value)}
              />
            </div>
          </div>

          {/* Botón para comparar */}
          <button className="btn btn-primary" onClick={compararPeriodos}>
            Comparar Períodos
          </button>

          {/* Tablas para mostrar los detalles */}
          <div className="row mt-4">
            <div className="col-md-6">
              <h4>Detalles del Período 1</h4>
              <h5>Total: ${formatMoney(totalPeriodo1)}</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Detalle pago</th>
                    {/* <th>Nombre del Auxiliar</th>
                    <th>Días</th> */}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {detallesPeriodo1.map((pago, index) => (
                    <tr key={index}>
                      <td>{pago.nombrePaciente}</td>
                      {/* <td>{pago.nombreAuxiliar}</td>
                      <td>{pago.dias}</td> */}
                      <td>${formatMoney(pago.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <h4>Detalles del Período 2</h4>
              <h5>Total: ${formatMoney(totalPeriodo2)}</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Detalle pago</th>
                    {/* <th>Nombre del Auxiliar</th>
                    <th>Días</th> */}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {detallesPeriodo2.map((pago, index) => (
                    <tr key={index}>
                      <td>{pago.nombrePaciente}</td>
                      {/* <td>{pago.nombreAuxiliar}</td>
                      <td>{pago.dias}</td> */}
                      <td>${formatMoney(pago.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompararPeriodo;